<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars></ProgressBars>
    <br aria-hidden="true" />

    <div v-show="newVersion()">
      <div class="blocnote-container">
        <div class="blocnote-area-new">
          <h1 class="title">{{ LG("HP_blocnoteButtonLabel") }}</h1>
          <Blocnote />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import Blocnote from "../components/Blocnote.vue";

export default {
  components: {
    ProgressBars,
    Blocnote,
  },

  data() {
    return {};
  },

  computed: {},

  created() {},

  mounted() {},

  methods: {},
};
</script>

<style scoped>
@media (max-width: 830px) {
  .media {
    display: block;
    text-align: center;
  }
  .date-note {
    text-align: center;
  }
  h2 {
    text-align: left;
  }
}

button:not(.funky-shape) {
  border: none;
  background-color: transparent;
}
.icon-btn {
  font-size: 1.3rem;
}
a {
  text-decoration: underline !important;
  color: black !important;
}
.flex1 {
  flex: 1;
}
.title {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
.nav.nav-tabs {
  margin-left: 50px;
}
.blocnote-container {
  margin-top: 24px;
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.blocnote-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px;
  min-height: 640px;
}
.back-btn,
h1 {
  margin-bottom: 20px;
}

@media (min-width: 600px) {
  .back-btn {
    float: left;
  }
}
.note-wrapper {
  clear: both;
  margin: 10px;
  padding: 10px;
}
.quill-editor {
  background-color: white;
}
.text-zone {
  flex: 1;
  padding: 10px 10px 0 10px;
  margin-bottom: 10px;
  background-color: white;
}
.note-thumbnail {
  width: 160px;
  height: 125px;
  object-fit: scale-down;
  margin-right: 20px;
  object-position: top;
}

@media print {
  .media {
    display: flex !important;
    text-align: left !important;
  }
  .date-note {
    text-align: left !important;
  }
  header,
  button,
  nav,
  br {
    display: none !important;
  }
  /* ::v-deep .ql-toolbar.ql-snow {
    display: none !important;
  }
  ::v-deep .ql-container.ql-snow {
    border-top: 1px solid #ccc !important;
    border: none !important;
  } */
  .site-background {
    padding: 0;
    margin: 0;
    max-width: none;
  }
  a {
    color: black !important;
  }
}
</style>
